
export const socialLinks = [
    { name: 'Facebook', value: 'facebook' },
    { name: 'Instagram', value: 'instagram' },
    { name: 'LinkedIn', value: 'linkedin' },
    { name: 'Reddit', value: 'reddit' },
    { name: 'Snapchat', value: 'snapchat' },
    { name: 'TikTok', value: 'tiktok' },
    { name: 'Twitch', value: 'twitch' },
    { name: 'Twitter', value: 'twitter' },
    { name: 'YouTube', value: 'youtube' },
    { name: 'Yahoo', value: 'yahoo' },
    { name: 'Microsoft', value: 'microsoft' },
    { name: 'Apple', value: 'apple' },
    { name: 'GitHub', value: 'github' },
    { name: 'Substack', value: 'substack' },
    { name: 'Clubhouse', value: 'clubhouse' },
    { name: 'Shopify', value: 'shopify' },
    { name: 'Spotify', value: 'spotify' },
    { name: 'Pinterest', value: 'pinterest' },
    { name: 'SoundCloud', value: 'soundcloud' },
    { name: 'BeReal', value: 'bereal' },
    { name: 'IMVU', value: 'imvu' },
    { name: 'LinkTree', value: 'linktree' },
    { name: 'WeChat', value: 'wechat' },
    { name: 'Line', value: 'line' },
    { name: 'Quora', value: 'quora' },
    { name: 'Skype', value: 'skype' },
    { name: 'Viber', value: 'viber' },
    { name: 'Stack Exchange', value: 'stackexchange' },
    { name: 'Zoom', value: 'zoom' },
    { name: 'Calendly', value: 'calendly' },
    { name: 'Dribble', value: 'dribble' },
    { name: 'Deviant Art', value: 'deviantart' },
    { name: 'Adobe', value: 'adobe' },
    { name: 'Behance', value: 'behance' },
    { name: 'Cameo', value: 'cameo' },
    { name: 'Bitcoin', value: 'bitcoin' },
    { name: 'Ethereum', value: 'ethereum' },
    { name: 'BirthDay', value: 'birthday' },
    { name: 'Add your own', value: 'add_your_own' },
    { name: 'Post News', value: 'post_news' },
    { name: 'PGP', value: 'Public Key' },
];
